module.exports = __webpack_public_path__ + "media/images/revenue_share_top-acb0a4c7697b91e0f9a256a46cefc8ef.png";